import React from 'react';
import { randomString } from 'helpers/string';
import { LienLaws } from 'components/LienLaws';
import { APP_CONFIG } from 'Config';
import Error404 from 'components/Errors/Error404';
import { USA } from 'helpers/constants/countries';

const LienLawsPage = () => {
    if (!APP_CONFIG.RELEASE_LIEN_LAWS) {
        return <Error404 />;
    }

    return <LienLaws country_id={USA.id} />; //default : US
};

interface LienLawsPageInitialProps {
    res: any
    store: {
        dispatch: any
    }
}

LienLawsPage.getInitialProps = async ({ res }: LienLawsPageInitialProps) => {
    if (!APP_CONFIG.RELEASE_LIEN_LAWS) {
        if (res) {
            res.statusCode = 404;
        }
        return {};
    }

    const pageData = {title: 'Lien Laws', marginBottom: 'pageTitle marginB20', h1: 'Lien Laws', description: undefined };

    const rand_str = randomString();

    return { rand_str, pageData };
};

export default LienLawsPage;